import * as React from 'react'
import { memo } from 'react'
const SvgCall = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path d="M14.883 16a11.6 11.6 0 0 1-5.078-1.286 18.4 18.4 0 0 1-4.948-3.6 18.8 18.8 0 0 1-3.571-4.935A11.5 11.5 0 0 1 0 1.117 1.1 1.1 0 0 1 .312.325 1.04 1.04 0 0 1 1.091 0h2.078a1.15 1.15 0 0 1 .766.273 1.44 1.44 0 0 1 .455.714l.468 2.13a1.66 1.66 0 0 1-.026.779 1.1 1.1 0 0 1-.364.545l-2.208 2a17.7 17.7 0 0 0 1.468 2.247 23 23 0 0 0 1.675 1.935 18 18 0 0 0 2.026 1.74 21 21 0 0 0 2.416 1.533L12 11.688a1.16 1.16 0 0 1 .558-.364 1.8 1.8 0 0 1 .688-.026l1.766.364a1.26 1.26 0 0 1 .714.442 1.2 1.2 0 0 1 .273.779v2.026a1.04 1.04 0 0 1-.325.779 1.1 1.1 0 0 1-.791.312" />
  </svg>
)
const Memo = memo(SvgCall)
export default Memo
